import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./stepOne.module.css";
import { toast } from "react-toastify";
import Header from "../../Header/Header";
import ProgressBar from "../../../components/ProgressBar";
import { showErrorToast } from "../../utils";
export default function SelectDocumentType() {
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [formData, setFormData] = useState({});
    const navigate = useNavigate();

    const handleOptionClick = (option) => {
        setSelectedDocument(option);
        setFormData((pre) => ({ ...pre, selectedIdType: option }));
    };
    const validateForm = () => {
        if (!formData.selectedIdType) {
            showErrorToast("Please select document type", {
                autoClose: 3000,
                pauseOnHover: false,
            });
            return false;
        }

        return true;
    };
    const handleSubmit = (e) => {
        try {
            e.preventDefault();
            if (validateForm()) {
                // localStorage.setItem("idType", formData.selectedIdType);
                navigate("/verify/step-2", {
                    state: {
                        idType: formData.selectedIdType,
                    },
                });
                // setSelectedStep(2);
            } else {
                return;
            }
        } catch (error) {
            console.log("error:", error);
        }
    };
    return (
        <div className="tw-flex tw-w-full tw-pt-[70px] tw-flex-col tw-h-screen tw-items-center tw-justify-between tw-px-[20px] max-sm:tw-px-4">
            <Header title={"Identity Verification"} />
            <ProgressBar currentStep={1} totalSteps={3} />
            <form
                onSubmit={handleSubmit}
                className={`${styles.optionsContainer} ${styles.rowLayout} tw-flex tw-max-w-[552px] max-sm:tw-max-w-full tw-w-full tw-flex-col tw-items-center tw-gap-4 tw-px-4`}
            >
                <p className="tw-font-[600] tw-text-[20px] max-sm:tw-text-[18px] tw-text-start tw-w-full max-sm:tw-text-center">
                    Choose Your ID Type
                </p>
                <div className="tw-flex tw-flex-col tw-border-1 tw-w-full tw-overflow-hidden tw-rounded-lg">
                    {[
                        { value: "driver_licence", label: "Driver's License" },
                        { value: "passport", label: "Passport" },
                        { value: "state_id", label: "State ID" },
                    ].map((option, index) => (
                        <div
                            key={index}
                            className={`${styles.option} ${selectedDocument === option.value ? styles.optionActive : ""} ${option.label === "National ID" ? "tw-border-none" : "tw-border-b-1"}`}
                            onClick={() => handleOptionClick(option.value)}
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
                <button type="submit" className={`${styles.submitButton} tw-bg-primary hover:tw-bg-primary_hover`}>
                    Next
                </button>
            </form>
            <div></div>
        </div>
    );
}
